import Emitter from "@digitalbranch/app/src/modules/emitter"
import { FormattedRegisters } from "@digitalbranch/vm/dist/modules/cpu/types"

const emulator = new Worker(new URL('./emulator.worker.ts', import.meta.url), { type: 'module' })
const emitter = new Emitter()

export type RegistersChanged = Partial<FormattedRegisters>

export type MemoryChanged = { address: string, contents: string, ascii: string }

export type PixelBuffer = { name: 'pixel_buffer', data: { red: number, green: number, blue: number, x: number, y: number } }

export const emulator_on_compiled = (cb: () => void) => {
  emitter.on('compiled', cb)

  return () => emitter.off('compiled', cb)
}

export const emulator_on_device = (cb: (device: PixelBuffer) => void) => {
  emitter.on('device', cb)

  return () => emitter.off('device', cb)
}

export const emulator_on_registers_changed = (cb: (registers: RegistersChanged) => void) => {
  emitter.on('registers_changed', cb)

  return () => emitter.off('registers_changed', cb)
}

export const emulator_on_memory_changed = (cb: (entry: MemoryChanged) => void) => {
  emitter.on('memory_changed', cb)

  return () => emitter.off('memory_changed', cb)
}

export const emulator_on_stdout = (cb: (data: ArrayBuffer | string) => void) => {
  emitter.on('stdout', cb)

  return () => emitter.off('stdout', cb)
}

export const emulator_on_ready = (cb: () => void) => {
  emitter.on('ready', cb)

  return () => emitter.off('ready', cb)
}

export const emulator_on_exit = (cb: (error: unknown) => void) => {
  emitter.on('exit', cb)

  return () => emitter.off('exit', cb)
}

export const emulator_on_error = (cb: (error: unknown) => void) => {
  emitter.on('error', cb)

  return () => emitter.off('error', cb)
}

function handleMessage(event: MessageEvent<{ type: string , data: any}>) {
  const { data: { type, data } } = event

  emitter.emit(type, data)
}

emulator.addEventListener('message', handleMessage)

export function emulator_compile(source: string) {
  emulator.postMessage({ type: 'compile', data: source })
}

export function emulator_run() {
  emulator.postMessage({ type: 'run' })
}

export function emulator_stop() {
  emulator.postMessage({ type: 'stop' })
}

export function emulator_step() {
  emulator.postMessage({ type: 'step' })
}